export default __webpack_public_path__ + "static/media/login.08af9483.png";